import {createAction, createReducer} from '@reduxjs/toolkit';

import {ItemsType, OrderStatusType} from 'types/successPage';

import {postEyeExam, saveOrder} from '../../actions/orderItems/orderItems';

export const initialState: OrderStatusType = {isError: false, isLoading: false, items: []};

export const updateItems = createAction<ItemsType>('SUCCESS_PAGE@UPDATE_ITEMS');
export const setIsOrderStatusHasError = createAction<boolean>(
    'SUCCESS_PAGE@SET_ORDER_STATUS_ERROR',
);

export const setOrderStatusLoadingState = createAction<boolean>(
    'SUCCESS_PAGE@SET_ORDER_STATUS_LOADING_STATE',
);

const handlePending = (state: OrderStatusType) => ({
    ...state,
    isError: false,
    isLoading: true,
});

const handleFulfilled = (state: OrderStatusType, {payload}: {payload: ItemsType}) => ({
    ...state,
    isError: false,
    isLoading: false,
    items: payload,
});

const handleRejected = (state: OrderStatusType) => ({
    ...state,
    isError: true,
    isLoading: false,
});

export const orderStatus = createReducer<OrderStatusType>(initialState, builder => {
    builder.addCase(updateItems, (state, {payload}) => ({
        ...state,
        isError: false,
        items: payload,
    }));
    builder.addCase(setOrderStatusLoadingState, (state, {payload}) => ({
        ...state,
        isError: false,
        isLoading: payload,
    }));
    builder.addCase(setIsOrderStatusHasError, (state, {payload}) => ({
        ...state,
        isError: payload,
        isLoading: false,
    }));

    [saveOrder, postEyeExam].forEach(action => {
        builder.addCase(action.pending, handlePending);
        builder.addCase(action.fulfilled, handleFulfilled);
        builder.addCase(action.rejected, handleRejected);
    });
});
